import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero, Section, Seo, Reveal, breadcrumb } from "@/components/site/Section";
import { FinalCTA } from "@/components/site/HomeSections";
import SEO from "@/data/seo-pages.json";

const META = SEO.core.find((c) => c.path === "/guides");

export default function Guides() {
  return (
    <>
      <Seo title={META.title} description={META.description} path="/guides" jsonLd={breadcrumb("Guides", "/guides")} />
      <PageHero eyebrow="Guides" title="Firewood guides & wood burner tips." intro={META.text} />
      <Section>
        <ul className="grid gap-6 md:grid-cols-2" data-testid="guides-list">
          {SEO.guides.map((g, i) => (
            <Reveal key={g.slug} delay={i * 0.05}>
              <Link to={`/guides/${g.slug}`} className="lc-card group flex h-full flex-col p-6 sm:p-8" data-testid={`guides-item-${g.slug}`}>
                <h2 className="font-display text-xl font-bold text-[#F7F5F0] transition-colors group-hover:text-[#FF6A00] sm:text-2xl">{g.h1}</h2>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-[#A1A1AA]">{g.description}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#FF6A00]">Read guide <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
              </Link>
            </Reveal>
          ))}
        </ul>
      </Section>
      <FinalCTA />
    </>
  );
}
